/**
 * Placeholder data for import wizard steps 2-5. Replace with the import API:
 * source catalogue, column mapping, validation results and the run summary.
 */

/* ------------------------------------------------------- 2. choose source -- */

export const IMPORT_SOURCES = [
  {
    key: "database",
    label: "Database Connection",
    text: "Import data from a database using secure connection.",
    icon: "database",
    tone: "green",
  },
  {
    key: "api",
    label: "API Integration",
    text: "Import data from an external API endpoint.",
    icon: "cloud",
    tone: "blue",
  },
  {
    key: "sftp",
    label: "SFTP / FTP",
    text: "Import data from a remote SFTP or FTP server.",
    icon: "folder",
    tone: "indigo",
  },
  {
    key: "flat",
    label: "Flat File (CSV / Excel)",
    text: "Import data from CSV, XLSX, XLS files.",
    icon: "file",
    tone: "amber",
  },
  {
    key: "cloudStorage",
    label: "Cloud Storage",
    text: "Import data from cloud storage services.",
    icon: "cloudUpload",
    tone: "sky",
  },
  {
    key: "other",
    label: "Other Systems",
    text: "Import data from other external systems or applications.",
    icon: "settings",
    tone: "red",
  },
];

/* ----------------------------------------------------------- 3. map data -- */

export const MAPPING_STATS = {
  totalColumns: 28,
  mapped: 23,
  mappedShare: 82,
  unmapped: 5,
  unmappedShare: 18,
};

export const SOURCE_COLUMNS = [
  "NIF",
  "Taxpayer Name",
  "Trade Name",
  "Entity Type",
  "Registration Date",
  "Address",
  "Province",
  "Activity Code",
  "Email",
  "Phone Number",
  "Credit Limit",
  "Payment Terms",
];

export const SYSTEM_FIELDS = [
  "Taxpayer Identification Number (NIF)",
  "Legal Name",
  "Trade Name",
  "Taxpayer Type",
  "Registration Date",
  "Address",
  "Province",
  "Primary Activity Code",
  "Email Address",
  "Phone Number",
];

/** Column-to-field pairs; an empty target means the column is unmapped. */
export const FIELD_MAPPINGS = [
  { source: "NIF", target: "Taxpayer Identification Number (NIF)" },
  { source: "Taxpayer Name", target: "Legal Name" },
  { source: "Trade Name", target: "Trade Name" },
  { source: "Entity Type", target: "Taxpayer Type" },
  { source: "Registration Date", target: "Registration Date" },
  { source: "Address", target: "Address" },
  { source: "Province", target: "Province" },
  { source: "Activity Code", target: "Primary Activity Code" },
  { source: "Email", target: "Email Address" },
  { source: "Phone Number", target: "Phone Number" },
  { source: "Credit Limit", target: "" },
  { source: "Payment Terms", target: "" },
];

export const MAPPING_TIPS = [
  "Use Auto Map to map fields with similar names.",
  "Review unmapped fields and select the correct system field.",
  "You can create custom fields if needed after import.",
];

export const MAPPING_PREVIEW = [
  { nif: "5001234567", name: "Global Imports SARL", type: "Company" },
  { nif: "5001234568", name: "Tech Solutions Lda", type: "Company" },
  { nif: "5001234569", name: "Comercio & Cia Lda", type: "Company" },
  { nif: "5001234570", name: "Ango Services SA", type: "Company" },
  { nif: "5001234571", name: "Build Angola Lda", type: "Company" },
];

/* ------------------------------------------------------ 4. validate data -- */

export const VALIDATION_TOTAL = "245,678";

export const VALIDATION_BREAKDOWN = [
  {
    label: "Valid Rows",
    value: 230812,
    share: 93.9,
    color: "#26a269",
    legendPrimary: "230,812",
    legendSecondary: "(93.9%)",
  },
  {
    label: "Errors",
    value: 6245,
    share: 2.5,
    color: "#df3f45",
    legendPrimary: "6,245",
    legendSecondary: "(2.5%)",
  },
  {
    label: "Warnings",
    value: 8954,
    share: 3.6,
    color: "#ef9c17",
    legendPrimary: "8,954",
    legendSecondary: "(3.6%)",
  },
  {
    label: "Duplicates",
    value: 2667,
    share: 1.1,
    color: "#9aa7bb",
    legendPrimary: "2,667",
    legendSecondary: "(1.1%)",
  },
  {
    label: "Empty Rows",
    value: 1000,
    share: 0.4,
    color: "#c9d3e0",
    legendPrimary: "1,000",
    legendSecondary: "(0.4%)",
  },
];

export const QUALITY_SCORE = 94;

export const TOP_ISSUES = [
  { label: "Invalid NIF format", count: "2,145", tone: "error" },
  { label: "Missing required fields", count: "1,842", tone: "error" },
  { label: "Invalid date format", count: "1,256", tone: "error" },
  { label: "Duplicate NIF", count: "987", tone: "warning" },
  { label: "Invalid email format", count: "15", tone: "info" },
];

export const VALIDATION_TABS = [
  { key: "all", label: "All Rows", count: "245,678" },
  { key: "Error", label: "Errors", count: "6,245" },
  { key: "Warning", label: "Warnings", count: "8,954" },
  { key: "Duplicate", label: "Duplicates", count: "2,667" },
  { key: "Empty", label: "Empty", count: "1,000" },
];

export const VALIDATION_ROWS = [
  {
    id: 1,
    nif: "5001234567",
    name: "Global Imports SARL",
    type: "Company",
    registered: "15/06/2022",
    email: "info@globalimports.co.ao",
    status: "Valid",
    issue: "—",
  },
  {
    id: 2,
    nif: "5001234568",
    name: "Tech Solutions Lda",
    type: "Company",
    registered: "22/07/2022",
    email: "contact@techsolutions.co.ao",
    status: "Valid",
    issue: "—",
  },
  {
    id: 3,
    nif: "123456789",
    name: "Invalid NIF Example",
    type: "Company",
    registered: "—",
    email: "invalidemail@",
    status: "Error",
    issue: "Invalid NIF format",
    badNif: true,
    badEmail: true,
  },
  {
    id: 4,
    nif: "5001234570",
    name: "Ango Services SA",
    type: "Company",
    registered: "05/08/2022",
    email: "info@angoservices.co.ao",
    status: "Warning",
    issue: "Missing phone number",
  },
  {
    id: 5,
    nif: "5001234567",
    name: "Duplicate NIF Example",
    type: "Company",
    registered: "12/04/2022",
    email: "duplicate@example.co.ao",
    status: "Error",
    issue: "Duplicate NIF",
    badNif: true,
  },
];

export const VALIDATION_RULES = [
  { text: "NIF must be unique and valid", tone: "ok" },
  { text: "Required fields must not be empty", tone: "ok" },
  { text: "Date format must be DD/MM/YYYY", tone: "ok" },
  { text: "Email format must be valid", tone: "warn" },
  { text: "Phone number format must be valid", tone: "ok" },
];

export const VALIDATION_SUMMARY = [
  { label: "Selected Source", value: "Database Connection", icon: "database" },
  {
    label: "File Name",
    value: "Taxpayer_Master_2026-09-01.xlsx",
    icon: "sheet",
  },
  { label: "File Size", value: "125.6 MB", icon: "file" },
  { label: "Total Rows", value: "245,678", icon: "grid" },
  { label: "Validated On", value: "01 Sep 2026 11:30 AM", icon: "clock" },
  { label: "Validated By", value: "John Doe", icon: "shield" },
];

/* ----------------------------------------------------- 5. import complete -- */

export const IMPORT_RESULT = [
  { label: "Import ID", value: "IMP-2026-09-01-10-45-32" },
  { label: "File Name", value: "Taxpayer_Master_2026-09-01.xlsx" },
  { label: "Source", value: "Database Connection" },
  { label: "Imported By", value: "John Doe" },
  { label: "Completed On", value: "01 Sep 2026 11:02 AM" },
  { label: "Duration", value: "2m 34s" },
];

export const RESULT_TILES = [
  {
    key: "total",
    value: "245,678",
    label: "Total Rows Processed",
    tone: "neutral",
    icon: "database",
  },
  {
    key: "imported",
    value: "230,812",
    label: "Rows Imported",
    share: "93.9%",
    tone: "good",
    icon: "check",
  },
  {
    key: "failed",
    value: "8,954",
    label: "Rows Failed",
    share: "3.6%",
    tone: "critical",
    icon: "error",
  },
  {
    key: "warnings",
    value: "4,912",
    label: "Rows with Warnings",
    share: "2.0%",
    tone: "warning",
    icon: "warn",
  },
  {
    key: "skipped",
    value: "1,000",
    label: "Empty Rows Skipped",
    share: "0.4%",
    tone: "muted",
    icon: "info",
  },
];

export const WHAT_NEXT = [
  {
    key: "available",
    title: "Data is now available",
    text: "The imported data is now available in the system and can be searched, viewed and managed.",
    icon: "database",
  },
  {
    key: "quality",
    title: "Quality monitoring",
    text: "Data quality checks will continue in the background to ensure accuracy and completeness.",
    icon: "shield",
  },
  {
    key: "jobs",
    title: "Integration jobs",
    text: "Scheduled integration jobs will use this data for future updates and syncs.",
    icon: "clock",
  },
  {
    key: "notify",
    title: "Notifications",
    text: "You will be notified if any issues are detected in the future.",
    icon: "bell",
  },
];

export const RESULT_SUMMARY = [
  { label: "Selected Source", value: "Database Connection", icon: "database" },
  {
    label: "File Name",
    value: "Taxpayer_Master_2026-09-01.xlsx",
    icon: "sheet",
  },
  { label: "File Size", value: "125.6 MB", icon: "file" },
  { label: "Total Rows", value: "245,678", icon: "grid" },
  {
    label: "Imported Rows",
    value: "230,812 (93.9%)",
    icon: "check",
    tone: "good",
  },
  {
    label: "Failed Rows",
    value: "8,954 (3.6%)",
    icon: "error",
    tone: "critical",
  },
  {
    label: "Warning Rows",
    value: "4,912 (2.0%)",
    icon: "warn",
    tone: "warning",
  },
  { label: "Skipped Rows", value: "1,000 (0.4%)", icon: "info", tone: "muted" },
  { label: "Imported On", value: "01 Sep 2026 11:02 AM", icon: "clock" },
  { label: "Imported By", value: "John Doe", icon: "user" },
  { label: "Duration", value: "2m 34s", icon: "clock" },
];

export const NEXT_STEPS = [
  { key: "view", label: "View Imported Data", icon: "grid" },
  { key: "quality", label: "Check Data Quality Dashboard", icon: "shield" },
  { key: "rules", label: "Create Data Quality Rules", icon: "file" },
  { key: "schedule", label: "Schedule Next Import", icon: "clock" },
  { key: "dashboard", label: "Go to Dashboard", icon: "home" },
];
